// The row Delete action on list tables: a small red trash icon instead of
// the word "Delete". Same icon and look as the Purchase / Sales forms'
// row remove (`.line-item-remove`).

export function DeleteIconButton({ onClick, title = 'Delete', disabled }: {
  onClick: () => void; title?: string; disabled?: boolean;
}) {
  return (
    <button type="button" className="row-del-btn" title={title} aria-label={title} disabled={disabled}
      onClick={e => { e.stopPropagation(); onClick(); }}>
      {/* The same trash icon as the Purchase / Sales forms' row remove (IconTrash). */}
      <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
        <path d="M2 3.5h10M5.5 3.5V2.5h3v1M4 3.5l.667 8h4.666L10 3.5"
          stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
